import { useTranslation } from 'react-i18next'
import { Box, Stack } from '@mui/material'

import EmptyScreen from 'packages/ui/EmptyScreen'
import { useSites } from 'store'

import { AccessPointZonesProvider } from './AccessPointZonesContext'
import Sidebar from './Sidebar'
import Body from './Body'
import { useTree } from './use-tree'

const AccessPointZonesContent = () => {
  const { error } = useTree()
  const { t } = useTranslation()
  return (
    <Box sx={{ position: 'relative', flex: 1 }}>
      <Stack
        direction={'row'}
        gap={1}
        sx={{ position: 'absolute', inset: 0, overflow: 'hidden' }}
      >
        {
          error ? (
            <EmptyScreen icon={'wifi'}>{t(`api_errors.${error.replaceAll('Errors::', '')}`)}</EmptyScreen>
          ) : (
            <>
              <Sidebar />
              <Box sx={{ flex: 1, height: '100%' }}>
                <Body />
              </Box>
            </>
          )
        }
      </Stack>
    </Box>
  )
}

const AccessPointZones = () => {
  const [{ selected }] = useSites()
  const { t } = useTranslation()

  if (selected.length !== 1) {
    return <EmptyScreen icon="wifi">{t('ran.no_site_selected')}</EmptyScreen>
  }

  return (
    <AccessPointZonesProvider>
      <AccessPointZonesContent />
    </AccessPointZonesProvider>
  )
}

export default AccessPointZones
